module.exports = __webpack_public_path__ + "static/evergreen-combobox-64312ae3129cd1bf28f0ef2d367c5ed9.png";